import { render, staticRenderFns } from "./RemittanceHeader.vue?vue&type=template&id=66f69358&scoped=true"
import script from "./RemittanceHeader.vue?vue&type=script&lang=js"
export * from "./RemittanceHeader.vue?vue&type=script&lang=js"
import style0 from "./RemittanceHeader.vue?vue&type=style&index=0&id=66f69358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f69358",
  null
  
)

export default component.exports